import { render } from "./AntrianItem.html?vue&type=template&id=c8994d86&ts=true&external"
import script from "./AntrianItem.ts?vue&type=script&lang=ts&external"
export * from "./AntrianItem.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__